export default "__VITE_ASSET__Dj9Dori7__"